import VerifyCationAlert from './VerifyCationAlert.vue';

VerifyCationAlert.install = (Vue) => {
  Vue.component(VerifyCationAlert.name, VerifyCationAlert);
};

export default VerifyCationAlert;
